import { getEnv } from '@config/config'
import { DirectBillingApp } from './DirectBillingApp'
import { MyClaimsApp } from './MyClaimsApp'
import { CtaApp } from './CtaApp'
import { OverviewApp } from './OverviewApp'
import { DrawerApp } from './DrawerApp'
import { createBasicWidgetHolder, createWidgetHolder } from './widgetHolder'
import { InsuranceToggleApp } from './InsuranceToggleApp'
import { InitializerApp } from './InitializerApp'
import { initWidgetEventListener } from './widgetEventListener'

const INITIALIZER_WIDGET_CONTAINER_ID = 'directBilling-initializer'

/**
 * Initialize widgets and make them available on window.directBilling object.
 * Each widget is independently rendered on the commerce F/E app.
 *
 * All widgets share the same global redux state. However, some widgets may
 * need to communicate with other widgets thru custom events. e.g. the ctaWidget
 * cannot directly render the drawer so it has to use the custom events.
 *
 * Note: the dbWidget contains the cta and the drawer and suits flows where the
 * cta and drawer are rendered on specific pages (CLE, VDE).
 *
 * For flows where the drawer needs to be rendered from every page, the toggleWidget
 * and drawerWidget must be used (NUA).
 */

const dbWidget = createWidgetHolder(DirectBillingApp, 'directbilling-main', '#insuranceApp')
const ctaWidget = createWidgetHolder(CtaApp, 'directbilling-cta', '#insuranceCtaApp')
const drawerWidget = createWidgetHolder(DrawerApp, 'directbilling-drawer', '#insuranceDrawerApp')
const toggleWidget = createWidgetHolder(InsuranceToggleApp, 'directbilling-toggle', '#insuranceToggleApp')
const overviewWidget = createWidgetHolder(OverviewApp, 'directbilling-overview', '#insuranceOverviewApp')
const myClaimsWidget = createWidgetHolder(MyClaimsApp, 'directbilling-myclaims', '#insuranceMyClaimsApp')

const env = {
  NULLIFY_CUTOFF_TIME: getEnv('REACT_APP_NULLIFY_CUTOFF_TIME'),
}

window.directBilling = {
  dbWidget,
  ctaWidget,
  drawerWidget,
  toggleWidget,
  overviewWidget,
  myClaimsWidget,
  env,
}

const initWidgets = () => {
  // attach widget listener to ensure we handle widger render events as soon as bundle is loaded
  initWidgetEventListener()

  // create widget for other initialization
  const selector = createInitializerWidgetContainer()
  const widgetHolder = createBasicWidgetHolder(InitializerApp)
  widgetHolder.new({ selector }).render()
}

const createInitializerWidgetContainer = (): string => {
  let container = document.getElementById(INITIALIZER_WIDGET_CONTAINER_ID) as HTMLDivElement
  if (!container) {
    container = Object.assign(document.createElement('div'), {
      id: INITIALIZER_WIDGET_CONTAINER_ID,
    })
    document.body.append(container)
  }
  return `#${INITIALIZER_WIDGET_CONTAINER_ID}`
}

export default initWidgets
